import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {userSettingsApi} from '../api';

export const userSettingsKeys = {
  all: ['user-settings'] as const
};

export function useUserSettingsQuery(options?: {enabled?: boolean}) {
  const client = useApiClient();

  return useQuery({
    queryKey: userSettingsKeys.all,
    queryFn: () => userSettingsApi.fetchUserSettings(client),
    select: response => response.data,
    enabled: options?.enabled
  });
}
